import {KebabHorizontalIcon, PencilIcon, TrashIcon} from '@primer/octicons-react'
import {ActionList, ActionMenu, IconButton} from '@primer/react'

interface ShortcutOptionsButtonProps {
  onEditView: () => void
  onDeleteView: () => void
}

export function ShortcutOptionsButton({onEditView, onDeleteView}: ShortcutOptionsButtonProps) {
  return (
    <ActionMenu>
      <ActionMenu.Anchor>
        <IconButton icon={KebabHorizontalIcon} aria-label="Saved view menu" variant="invisible" />
      </ActionMenu.Anchor>
      <ActionMenu.Overlay width="small">
        <ActionList>
          <ActionList.Item onSelect={onEditView}>
            <ActionList.LeadingVisual>
              <PencilIcon />
            </ActionList.LeadingVisual>
            Edit view
          </ActionList.Item>

          <ActionList.Divider />

          <ActionList.Item variant="danger" onSelect={onDeleteView}>
            <ActionList.LeadingVisual>
              <TrashIcon />
            </ActionList.LeadingVisual>
            Delete
          </ActionList.Item>
        </ActionList>
      </ActionMenu.Overlay>
    </ActionMenu>
  )
}

try{ ShortcutOptionsButton.displayName ||= 'ShortcutOptionsButton' } catch {}